// api常量

export const GET_CONFIG_INDEX = '/api/exam/practice/getConfig'                // 模拟考试联系首页配置信息

export const GET_CONFIG = '/api/exam/getConfig'                               // 模拟考试配置信息获取

export const GET_PAPER = '/api/exam/paper/getConfig'                          // 学科试卷配置信息获取
export const TASK_SIGN_AGREEMENT = '/api/userSign/agreement'                  //  获取任务协议

export const GET_QUESTIONS = '/api/exam/paper/getQuestions'                   // 获取整套试卷考试题目

export const GET_DETAILS = '/api/exam/paper/question/getDetails'              // 获取单个考试题目

export const GET_RESULTS = '/api/exam/getResults'                             // 获取考试结果

export const SAVE_ANSWER = '/api/exam/paper/saveAnswer'                       // 试卷提交答案

export const GET_REMAIN_TIMES = '/api/exam/paper/getRemainTimes'              // 试卷提交答案

export const TEST_EXAM_PAPER_REPORT = '/api/exam/paper/report'                // 获取考试结果报告

export const TEST_GET_PRACTICES = '/api/exam/getPractices'                    // 练习列表获取

export const TEST_GET_QUESTIONS = '/api/exam/practice/getQuestions'           // 练习试题列表获取

export const TEST_SAVE_ANSWERS = '/api/exam/practice/saveAnswers'             // 练习提交答案

export const GET_PASSPORT = '/api/contest/passport/getPassport'               // 获取准考证详情/api/passport/getPassport

export const GET_PASSPORTINFO = '/api/passport/getPassport'               // 获取准考证详情新

export const UPDATE_STATUS = '/api/contest/passport/updateStatus'             // 是否已完成准考证||包括选择志愿的

export const GET_PASSPORT_STATUS = '/api/contest/passport/getPassportStatus'  // 选择志愿状态

export const ORDER_PRE_INFO = '/api/order/pre/info'                           // 订单预览

export const SCHOOL_LIST = '/api/common/school/list'                          // 获取报名信息学校列表

export const SCHOOL_LIST_ALL = '/api/common/school/list/all'                          // 新的学校查询接口

export const COMMON_GETAREA = '/api/area/getArea'              // 获取区域

export const SCHOOL_SENDEMAIL = '/api/common/school/sendEmail'  // 新增学校申请

export const SCHOOL_GETAREA_SCHOOL = '/api/area/getArea/school'  // 学生端优化省市区学校接口

export const ORDER_ORDER = '/api/order/order'                                 // 创建订单

export const ORDER_INOF = '/api/order/info'                                   // 订单详情/api/order/info/h5

export const ORDER_INOF_H5 = '/api/order/info/h5'                             // 订单详情免登录

export const WECHAT_OPENID = '/api/wechat'                                    // 获取微信公众号openId

export const WECHAT_OPENID_MALLBOOK = '/api/wechat/mallbook'                  // 获取微信公众号openId

export const PAY_INFO = '/api/order/payInfo'                                  // 支付信息

export const ORDER_STATUS = '/api/order/status'                               // 支付状态回调ORDER_SWITCH

export const ORDER_SWITCH = '/api/order/switch'                               // 支付状态回调

export const PAY_REDIRECT_PAY = '/api/order/jump/pay'                         // 扫码支付信息接口

export const ORDER_REFUND = '/api/order/refund'                               // 退款信息

export const ENTER_POST = '/api/contest/enter/post'                           // 报名信息提交

export const ENTER_FIND = '/api/contest/enter/find'                           // 查询信息提交
export const ENTER_CARD_IDENTIFY = '/api/contest/enter/card/identify'                           // 查询信息提交

export const ORDER_PRE_REFUND = '/api/order/pre/refund'                       // 退款预览

export const PROMOTION_INFO = '/api/contest/promotion/info'                   // 晋级结果结果

export const USER_LOGON = '/api/user/login'                                   // 登录

export const USER_UPDATE = '/api/user/update'                                 // 用户信息修改

export const PASSWORD_UPDATE = '/api/user/password/update'                    // 用户密码修改

export const CONTEST_LIST = '/api/common/contest/list'                        // 赛事列表

export const SEASON_INFO = '/api/common/season/info'                          // 赛季详情

export const TASK_LIST = '/api/common/season/task/list'                       // 赛季任务列表

export const TASK_VALIDATE = '/api/common/task/validate'                      // 任务跳转验证

export const COUPON_LIST = '/api/coupon/list'                                 // 优惠券

export const CERTIFICATE_LIST = '/api/contest/certificate/list'               // 获取证书

export const CERTIFICATE_SEND = '/api/contest/certificate/send'               // 证书发送邮箱

export const TASK_LIST_SON = '/api/common/task/list'                          // 任务的子任务列表

export const TASK_DONE = '/api/common/task/done'                              // 完成任务接口

export const THIRDPARTY_INFO = '/api/user/thirdparty/info'                    // 查询绑定第三方绑定账号

export const THIRDPARTY_BIND = '/api/user/thirdparty/bind'                    // 绑定第三方账号

export const TEAM_INFO = '/api/contest/team/info'                             // 查看组队信息
export const ACCOUNT_USER_GETSMSCODE = '/api/user/getSmsCode'                  // 带图形验证码账号验证码发送
export const USER_GRAPHCODE = '/api/user/graphcode'                           // 获取图形验证码

export const USER_GETSMSCODE = '/api/user/getSmsCode'                         // 获取短信验证码

export const USER_REGISTER = '/api/user/register'                             // 用户注册接口

export const VALIDATE_SMSCODE = '/api/user/validate/smscode'                  // 校验短信验证码

export const PSD_RECOVER = '/api/user/password/recover'                       // 用户重新设置密码接口

export const MATERIAL_LIST = '/api/material/list'                             // 比赛资料列表

export const RANK_LIST = '/api/rank/list'                                     // SIC周排行榜

export const USER_LOGOUT = '/api/user/logout'                                 // 退去登录（token存在）

export const USER_WECHAT_REGISTER = '/api/user/wechat/register'   // 微信绑定新账号注册
export const USER_INFO_GET = '/api/user/account/get'    // 获取用户账号接口

export const LOGIN_STATE = '/api/user/loginState'                             // 查询是否登录

export const COMMON_UPLOAD = '/api/common/upload'                             // 上传文件

export const COMMON_API_GET_FILE = '/api/file/getFile'                        // 获取阿里云文件

export const INVOICE_INFO = '/api/order/invoice/info'                         // 开具发票信息查询

export const INVOICE_SAVE = '/api/order/invoice/open'                         // 开具发票信息保存

export const INVOICE_SENDEMADL = '/api/order/invoice/sendmail'                // 发送发票到报名邮箱地址

export const INVOICE_COMPANY = '/api/common/invoice/company/search'           // 开具发票信息抬头查询

export const ENTRY_INFO = '/api/entry/entryInfo'                              // 个人参赛信息

export const GUARDIAN_ADD = '/api/guardian/add'                               // 添加监护人

export const GUARDIAN_UPDATE = '/api/guardian/update'                         // 修改监护人

export const GUARDIAN_INFO = '/api/guardian/info'                         // 查询监护人
export const HONOR_QUERY = '/api/honor/query'                         // 查询监护人

export const CONTRACT_INFO = '/api/contract/info'                             // 查看项目协议详情

export const AGREEMENT_PRE_INFO = '/api/agreement/pre/info'                   // 查看项目协议HTML

export const CONTRACT_PRE_INFO = '/api/contract/pre/info'                     // 查看项目协议首页信息

export const CONTRACT_USERSIGN = '/api/agreement/user/sign'                   // 签名

export const CONTRACT_USERSIGNV3 = '/api/agreement/user/sign/v3'                   // 新签名接口

export const PARTNER_LIST = '/api/partner/taskRelation/list'                   // 获取协议任务关联的合作方信息列表

export const CONTRACT_DETAIL = '/api/contract/detail'                         // 根据订单查看项目协议详情

export const CONTRACT_SENDMAIL = '/api/contract/sendMail'                     // 发送邮箱

export const USER_INFO = '/api/user/info'                                     // 获取用户信息接口

export const REPORTCARD_INFO = '/api/reportCard/reportCardInfo'               // 成绩单

export const ACADEMIC_INFO = '/api/academic/user/info'               // 学术报告

export const GET_GROUPS = '/api/contest/enter/getGroups'                      // 获取组别

export const CURRICUKA_INFO = '/api/curricula/curriculaInfo'                  // 获取课程内容详情

export const TEAM_SHARE_DETAIL = '/api/team/shareDetail'                            // 获取组队详情

export const CATEGORY_LIST = '/api/common/section/category/list'              // 日程内赛程列表

export const JOIN_INVITE = '/api/team/joinByInvite'                           // 接受邀请组队

export const GET_EXTRA = '/api/common/task/getExtraJson'                      // 获取下个任务

export const INVITE_TEAM = '/api/team/invite'                                 // 发送邀请

export const SEASON_LIST = '/api/contest/training/season/my/list'             // 我参与的活动列表

export const MY_LIST = '/api/contest/training/season/home/my/list'             // 无需登录参与的活动列表

export const TASK_DETAIL = '/api/common/task/detail'                          // 活动详情

export const APP_SEASON_LIST = '/api/contest/training/season/list'            // 项目列表  TASK_USER_SIGN: '/api/userSign/sign',                             //  同意任务协议

export const WX_TICKIT = '/api/weChat/getwxTickit'                            // 获取微信签名

export const TASK_USER_SIGN = '/api/userSign/sign'                             //  同意任务协议

export const IDENTITY_INFO = '/api/user/identity/info'                        // 项目列表

export const TEAM_INFOS = '/api/team/detail'                                  // 获取团队详情

export const PRE_PHONE = '/api/area/mobilePres/list'                          // 查询区号列表

export const LOGIN_NAME = '/api/user/loginName'                               // 查询当前登录用户

export const EXCHANGE_COUPONL = '/api/coupon/exchangeCoupon'                  // 兑换优惠券

export const ENTER_GRADES = '/api/contest/enter/grades'                       // 查询年级限制

export const COMMON_FEEDBACK = '/api/common/feedback'                         // 用户反馈

export const COMMON_GET_ALBUM = '/api/album/list'                             // 相册列表

export const COMMON_GET_ALBUM_CHILDREN = '/api/album/children'                // 相册子集

export const COMMON_GET_BANNERS = '/api/common/getBanners'                    // 广告轮播图

export const COMMON_CONTENT_LIST = '/api/content/list'                        // 相册内容列表

export const SET_GROUP = '/api/contest/group/setGroup'                        // 设置组别

export const GROUP_INFO = '/api/contest/group/groupInfo'                      // 组别信息

export const BANK_GET_QUESTION = '/api/exam/bank/getQuestion'                 // 获取题目

export const SAVE_CURRICULA_ANSWER = '/api/exam/saveCurriculaAnswer'          // 提交 问题

export const SHARE_INFO = '/api/share/info'                                   // 分享信息

export const SUBMIT_REFUND = '/api/order/submitNcpRefund'                    // 特殊退款申请

export const TEST_GET_ALL_QUESTIONS = '/api/exam/bank/getQuestions'          // 一次获取全部的作业题目

export const MANAGE_CHECK_WORK = '/api/work/manage/checkWork'                // 是否可以提交课程/任务题目

export const COMMON_INFO = '/api/commonInfo/commonInfo'                      //  获取信息分发详情

export const COMMON_GET_FILE_STS = '/api/file/getSts'                        // 获取sts

export const WECHAT_LOGIN = '/api/common/wechat/bindWeChatPublic'             // 绑定微信

export const DD_PROCESSINFO = '/oms/dingding/getProcessInfo'                  // 查询审批页详情

export const DD_NOLOGIN = '/oms/dingding/noLogin'                             // 通过钉钉回调拿到用户信息

export const DD_APPROVE = '/oms/contest/orderApply/approve'                   // 钉钉审批

export const BIND_USERID = '/api/commonInfo/bindUserId'                       //  用户绑定信息分发

export const VIDEO_PLAY_INFO = '/api/video/playInfo'                          // 获取直播配置信息

export const COMMON_GET_CHAT_GROUP = '/api/im/chatGroup/getChatGroup'         // 获取聊天室

export const COMMON_GET_USER_SIG = '/api/im/user/getUserSig'                  // 获取userSig

export const CHAT_USERS = '/api/user/chat/users'                              // 获取直播间人数

export const PRAISE_FIND = '/api/interaction/praise/find'                     // 获取是否点赞

export const WEB_PRAISE_SAVE = '/api/interaction/praise/save'                 // 这是点赞

export const COMMON_GET_CLASSFICATION = '/api/common/classification/get'      // 获取详情分类

export const COMMON_GET_DETAILS_GET = '/api/common/details/get'               // 查询具体的详情页内容

export const JOINT_LIST = '/api/jointCoupon/list'                             // 联名活动列表

export const JOINT_INFO = '/api/jointCoupon/redirect'                         // 联名活动跳转信息

export const JOINT_EXCHANGE = '/api/jointCoupon/exchange'                     // 领取活动优惠券

export const TEST_ANALYZE = '/api/exam/practice/analyze'                      // 练习成绩报告

export const TEST_RESTART = '/api/exam/practice/restart'                      // 练习再来一次

export const INVITATION_STATUS = '/api/coupon/getInvitationCouponCodeStatus'  // 获取是否有推广活动按钮

export const INVITATION_CODE = '/api/coupon/getInvitationCouponCode'          // 获取是否有推广活动吗

export const WECHAT_JUMP = '/api/common/wechat/wxjump'                        // 微信登录

export const WECHAT_JUMP_TEST = '/api/user/wechat/index'                        // 微信登录测试

export const REFUND_VALIDATION = '/api/order/refund/validation'               // 校验是否能退款

export const COMMON_GET_FILE_PUB_STS = '/api/file/getPubSts'                  // 上传文件公共

export const FILE_UPLOAD = '/api/common/upload'                               // 文件上传

export const GET_SMS_VALIDATE = '/api/user/getSmsCodeLogin'                   // 获取短信验证码

export const COUPON_PAGE = '/api/coupon/page'                                 // 优惠券列表

export const TASK_INFO = '/api/common/task/detail'                            //  获取任务详情

export const DYNAMIC_LIST = '/api/dynamic/list'                               // 动态列表

export const TEAM_INVITE = '/api/team/invite'                                 // 发送邀请

export const TEAM_DETAIL = '/api/team/detail'                                 // 组队详情

export const TEAM_SCHOOL = '/api/team/teamSchools'                            // 组别学校

export const UPDATE_SCHOOL = '/api/team/updateTeamSchools'                    // 修改学校

export const CHANG_LEADER = '/api/team/changLeader'                           // 更换队伍队长

export const REMOVE_MEMBERS = '/api/team/removerMembers'                      // 移除队员

export const TEAM_UPDATE = '/api/team/update'                                 // 修改团队信息

export const RECOMMEN_USERS = '/api/team/recommendUsers'                      // 搜索站内邀请人员

export const GTE_TEAMLIST = '/api/team/getTeamList'                           // 获取组队推荐列表

export const TEAM_QUIT = '/api/team/quit'                                     // 退出团队

export const DUSSOLVE_TEAM = '/api/team/dissolveTeam'                         // 解散团队

export const CONFIRM_TEAM = '/api/team/confirmTeam'                           // 确定组队

export const CHECK_NAME = '/api/team/checkName'                               // 检查队名合法性

export const CREATE_TEAM = '/api/team/create'                                 // 创建新的团队

export const TEAM_LIST = '/api/team/myTeams'                                  // 团队列表

export const TEAM_CONFIG = '/api/team/teamConfig'                             // 获取队伍配置 COMMON_NOTICE_LIST

export const MESSAGE_LIST = '/api/pushMessage/listByType'                     // 消息列表

export const COMMON_NOTICE_LIST = '/api/notice/getNoticeList'               // 查询公告列表
export const PUSHMESSAGE_READMESSAGE = '/api/pushMessage/readMessage'                 // 读消息
export const COMMON_NOTICE_INFO =  '/api/notice/getNotice'              // 公告详情

export const MESSAGE_UNREADNUM = '/api/pushMessage/unReadNum'                 // 消息列表数量

export const MESSAGE_UNREADNUM_TOTAL = '/api/pushMessage/unReadTotal'         // 活动消息总数量

export const ORDER_LIST = '/api/order/list'                                  // 订单列表

export const COMMON_ONLINE_LIST = '/api/video/live/online/list'               // 获取直播

export const MESSAGE_UNREADALL = '/api/pushMessage/unReadAll'               // 消息中心未读总数

export const CERTIFICATE_GET = '/api/contest/certificate/get'           // 获取教练端分享证书

export const ENTER_PINYIN = '/api/contest/enter/pinyin'           // 文字转拼音

export const USER_TAG_LIST = '/api/tag/list'                    // 标签查询



// WEBPACK FOOTER //
// ./src/assets/api/common/api-constant.js